<template>
   <div class="report">
      <div class="infoBox">
         <div class="box">
            <canvas id="repeat-watermark"></canvas>
            <p class="title">疑似假货报告提交</p>
            <van-cell-group>
               <van-field
               v-model="formData.customerName"
               required
               clearable
               label="客户姓名"
               placeholder="必填"
               @focus="inputFocus('customerName')"
               :error-message="checkInfo.customerName" />
            </van-cell-group>
            <van-cell-group>
               <van-field
               v-model="formData.phoneNum"
               required
               clearable
               type="number"
               maxlength="11"
               label="手机号码"
               placeholder="必填"
               @focus="inputFocus('phoneNum')"
               :error-message="checkInfo.phoneNum" />
            </van-cell-group>
            <van-cell-group>
               <van-field
               v-model="formData.sellerName"
               required
               clearable
               label="卖家名称"
               placeholder="必填"
               @focus="inputFocus('sellerName')"
               :error-message="checkInfo.sellerName" />
            </van-cell-group>
            <van-cell-group>
               <van-field
               v-model="formData.sellerphone"
               required
               clearable
               type="number"
               maxlength="11"
               label="卖家电话"
               placeholder="必填"
               @focus="inputFocus('sellerphone')"
               :error-message="checkInfo.sellerphone" />
            </van-cell-group>
            <van-cell-group>
               <van-field
               v-model="formData.goodsModel"
               clearable
               label="产品型号"
               placeholder="请输入" />
            </van-cell-group>
            <van-cell-group>
               <van-field
               v-model="formData.purchaseQuantity"
               clearable
               label="购买数量"
               placeholder="请输入" />
            </van-cell-group>
            <van-cell-group>
               <van-field
               v-model="formData.totalSum"
               clearable
               label="总金额(元)"
               placeholder="请输入" />
            </van-cell-group>
         </div>
         <span class="decorate1"></span>
         <span class="decorate2"></span>
      </div>
      <div class="action">
         <button class="onceMore" @click="submit">提交</button>
      </div>
      <div class="fixed-water-mark" style="display: none;">
         <canvas id="watermark" width="100" height="80"></canvas>
      </div>
   </div>
</template>

<script>
   export default {
      data() {
         return {
            imgUrl: "",
            formData: {
               customerName: "",
               phoneNum: "",
               sellerName: "",
               sellerphone: "",
               goodsModel: "",
               purchaseQuantity: "",
               totalSum: ""
            },
            checkInfo: {
               customerName: "",
               phoneNum: "",
               sellerName: "",
               sellerphone: ""
            }
         }
      },
      mounted() {
         this.init();
      },
      methods: {
         init() {
            let XVal = parseInt(Math.random()*(25-5+1)+5, 10);
            let YVal = parseInt(Math.random()*(60-55+1)+55, 10);
            let image = new Image();
            image.src = "data:image/png;base64,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";
            //绘制单个水印
            let cw = document.getElementById('watermark');
            let ctx = cw.getContext("2d");
            ctx.clearRect(0, 0, 80, 50);//清空矩形
            ctx.rotate(-20 * Math.PI / 180);//逆时针旋转20度
            image.onload = function(){
               ctx.drawImage(image, 18, 39, 63, 21);
               //在另一个画布上重复绘制单个水印
               let crw = document.getElementById('repeat-watermark');
               crw.width = window.innerWidth;//设置画布宽度等于窗口显示宽度
               crw.height = window.innerHeight;//设置画布高度等于窗口显示高度
               let ctxr = crw.getContext("2d");
               ctxr.clearRect(0, 0, crw.width, crw.height);
               let pat = ctxr.createPattern(cw, "repeat");//在水平和垂直方向重复绘制单个水印
               ctxr.fillStyle = pat;
               ctxr.fillRect(0, 0, crw.width, crw.height);
            }
         },
         inputFocus(name) {
            this.checkInfo[name] = "";
         },
         submit() {
            let data = this.formData;

            if(data.customerName == "") {
               this.checkInfo.customerName = "请输入客户姓名";
               return;
            }

            if(data.phoneNum == "") {
               this.checkInfo.phoneNum = "请输入手机号码";
               return;
            } else if(!/^1[3456789]\d{9}$/.test(data.phoneNum)) {
               this.checkInfo.phoneNum = "手机号码格式错误";
               return;
            }

            if(data.sellerName == "") {
               this.checkInfo.sellerName = "请输入卖家名称";
               return;
            }

            if(data.sellerphone == "") {
               this.checkInfo.sellerphone = "请输入卖家电话";
               return;
            } else if(!/^1[3456789]\d{9}$/.test(data.sellerphone)) {
               this.checkInfo.sellerphone = "卖家电话格式错误";
               return;
            }
         }
      }
   }
</script>

<style lang="less" scoped>
   .report {
      padding: 12px;
      .infoBox {
         box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.06);
         background-color: #FFF;
         padding: 24px 16px 0;
         border-radius: 6px;
         position: relative;
         .box {
            position: relative;
            overflow: hidden;
            #repeat-watermark {
               width: 100%;
               position: absolute;
               top: 50px;
               right: 0;
               bottom: 0;
               left: 0;
            }
            .title {
               line-height: 30px;
               font-size: 21px;
               text-align: center;
               font-weight: bold;
               color: #CF3139;
               padding-bottom: 24px;
            }
            .van-cell-group {
               border-top: 1px solid rgba(237, 237, 237, .6);
               background-color: initial;
               &::after {
                  border: none;
               }
               .van-cell {
                  height: 63px;
                  padding: 20px 0 0 10px;
                  background-color: initial;
                  &::before {
                     left: 0;
                     font-weight: bold;
                  }
                  .scanBtn {
                     width: 18px;
                     height: 18px;
                     display: inline-block;
                     border: none;
                     background-color: #FFF;
                     margin-right: 4px;
                     .scan_icon {
                        width: 100%;
                        height: 100%;
                     }
                  }
                  .code {
                     width: 60px;
                     line-height: 20px;
                     font-size: 16px;
                     border: none;
                     background-color: #FFF;
                     background-color: #CF3139;
                     color: #FFF;
                     padding: 2px 0;
                  }
               }
            }
         }
         .decorate1, .decorate2 {
            height: 9px;
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
            background-color: #FFF;
            box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.06);
            position: absolute;
         }
         .decorate1 {
            width: 96%;
            bottom: -9px;
            left: 2%;
            z-index: -1;
         }
         .decorate2 {
            width: 92%;
            bottom: -18px;
            left: 4%;
            z-index: -2;
         }
      }
      .action {
         margin-top: 36px;
         button {
            width: 100%;
            height: 45px;
            line-height: 45px;
            border-radius: 45px;
            border: none;
            font-size: 19px;
            text-align: center;
            color: #FFF;
            display: -webkit-flex;
            display: -webkit-box;
            display: flex;
            align-items: center;
            -webkit-align-items: center;
            justify-content: center;
            -webkit-justify-content: center;
            &.onceMore {
               margin-top: 12px;
               background-color: #CF3139;
            }
         }
      }
   }
</style>